import { ApiAgreement } from '@/containers/api-agreement';

export default function ApiAgreementRoute() {
  return <ApiAgreement />;
}
